import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from '@wayste/sour-ui';
import { HiOutlineCheckCircle, HiOutlineExclamationCircle, HiOutlineExclamationTriangle, HiOutlineInformationCircle, } from 'react-icons/hi2';
const SourAlert = ({ severity, message }) => {
    const getColor = () => {
        switch (severity) {
            case 'error':
                return 'bg-red-50 text-red-900';
            case 'warning':
                return 'bg-orange-50 text-orange-900';
            case 'info':
                return 'bg-blue-50 text-blue-900';
            case 'success':
            default:
                return 'bg-green-50 text-green-900';
        }
    };
    const getIcon = () => {
        switch (severity) {
            case 'error':
                return _jsx(HiOutlineExclamationCircle, { className: "size-6" });
            case 'warning':
                return _jsx(HiOutlineExclamationTriangle, { className: "size-6" });
            case 'info':
                return _jsx(HiOutlineInformationCircle, { className: "size-6" });
            case 'success':
            default:
                return _jsx(HiOutlineCheckCircle, { className: "size-6" });
        }
    };
    return (_jsxs("div", { className: `${getColor()} flex items-center gap-1 rounded px-4 py-1.5 text-sm`, children: [_jsx("div", { children: getIcon() }), _jsx("div", { className: "ml-2 py-2", children: message })] }));
};
export const Alert = ({ isAlertActive, closeAlert, alertProps, }) => {
    const { handleOnClose, closeBtnTitle, customBtn, message, severity, title } = alertProps;
    const close = () => {
        handleOnClose?.();
        closeAlert();
    };
    const customBtnClick = () => {
        customBtn?.customBtnFunction();
        if (!customBtn?.excludeHandleClose) {
            close();
        }
        else {
            closeAlert();
        }
    };
    const handleCloseReason = () => {
        close();
    };
    return (_jsxs(Dialog, { styledTitle: title, variant: "underlined-header", open: isAlertActive, onClose: handleCloseReason, className: "max-w-xl", disableCloseOnClickOutside: true, children: [_jsx("div", { className: "py-4 text-gray-700", children: severity ? _jsx(SourAlert, { severity: severity, message: message }) : message }), _jsxs("div", { className: "flex justify-end", style: {
                    flexDirection: customBtn?.switchPosition ? 'row-reverse' : 'row',
                }, children: [customBtn && (_jsx("button", { className: "btn-primary-text-only", onClick: customBtnClick, type: "button", children: customBtn.customBtnTitle })), _jsx("button", { className: "btn-primary-text-only", onClick: close, autoFocus: true, type: "button", children: closeBtnTitle || 'Okay' })] })] }));
};
//# sourceMappingURL=alert.js.map